export default class Diagonal {
    constructor() {
        this.elements = {
            items: document.querySelectorAll(".js-diagonal")
        };

        this.settings = {
            angle: 6
        };

        this.multiplier = (100 / 45) * this.settings.angle;

        // Bind this to functions
        this.setClipPath = this.setClipPath.bind(this);

        if (this.elements.items.length) {
            this.setClipPath();
            this._setDOMReferences();
        }
    }

    _setDOMReferences() {
        window.addEventListener("resize", this.setClipPath);
    }

    setClipPath() {
        for (let i = 0; i < this.elements.items.length; i++) {
            const item = this.elements.items[i];
            const itemW = item.offsetWidth;
            const inverse = item.dataset.diagonalInverse ? true : false;

            const pointOffset = (itemW / 100) * this.multiplier;

            let clippath =
                "polygon(0 0, 100% 0, 100% calc(100% - " +
                pointOffset / 10 +
                "rem), 0 100%)";

            if (inverse) {
                clippath =
                    "polygon(0 " +
                    pointOffset / 10 +
                    "rem, 100% 0, 100% 100%, 0 100%)";
            }

            item.style.clipPath = clippath;
            item.style.webkitClipPath = clippath;

            if (item.dataset.diagonalPadding != "false") {
                if (inverse) {
                    item.style.paddingTop = pointOffset / 10 + "rem";
                } else {
                    item.style.paddingBottom = pointOffset / 10 + "rem";
                }
            }
        }
    }
}
